import {ToastProviderProps} from '@chakra-ui/react';

export const toastTheme: ToastProviderProps = {
  defaultOptions: {
    position: 'top-right',
    variant: 'subtle',
    status: 'success',
    isClosable: true,
    duration: 2000,
  },
};
